import React, { Component, useEffect, useState } from "react";
import { Grid, Card, Form, Button, Tag } from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Crud_Catalogos from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";
import TablePageable from "../../Helpers/TablePageable.react";
import Select from "react-select";

const  UsuariosMfaPage =()=> {
  const [plataformas, setPlataformas]= useState([{value: 0, label: "Selecciona una opción"}]);
  const [usuarios, setUsuarios]= useState([]);
  const [plataformaSeleccionada, setPlataformaSeleccionada]= useState({value: 0, label: "Selecciona una opción"});
  const [loading, setLoading]= useState(false);
  
  useEffect(()=>{
    cargarPlataformas();
  },[]);

  useEffect(()=>{
    if(plataformaSeleccionada.value){
      cargarUsuarios(plataformaSeleccionada.value);
    }
  },[plataformaSeleccionada]);

  const cargarPlataformas = () => {
    Crud_Catalogos("plataformas/usuario/6", "", "get", "", [])
      .then((res) =>{
        let plataformasTem= [{value: 0, label: "Selecciona una opción"}];
        for(let p of res){
          plataformasTem.push({value: p.id, label: p.nombre, data: p});
        }
        setPlataformas(plataformasTem);
      })
      .catch(() => NotificationManager.error("Error al cargar plataformas"));
  };

  const cargarUsuarios = (plataformaId) => {
    setLoading(true);
    Crud_Catalogos("usuarios/plataforma/" + plataformaId, "", "get", "", [])
      .then((res) =>{
        setUsuarios(res || []);
        setLoading(false);
        }
      )
      .catch(() => {
        NotificationManager.error("Error al cargar usuarios");
        setLoading(false);
      });
  };

  const toggleMfa = (usuario) => {
    const updatedUser = { ...usuario, isUsingMfa: !usuario.isUsingMfa };
    Crud_Catalogos("usuarios", "", "put", "", updatedUser)
      .then(() => {
        NotificationManager.success(
          `MFA ${updatedUser.isUsingMfa ? "activado" : "desactivado"} para ${usuario.username}`
        );
        cargarUsuarios(plataformaSeleccionada.value);
      })
      .catch(() => NotificationManager.error("Error al actualizar MFA"));
  };

  return (
    <SiteWrapper>
      <div className="container mt-3">
        <Grid.Row>
          <Grid.Col sm={12} lg={12}>
            <Card>
              <Card.Header>
                <Card.Title>
                  Usuarios MFA
                </Card.Title>
              </Card.Header>
              <Card.Body>
                {loading ? (
                  <div>Cargando...</div>
                ) : (
                  <TablePageable
                    titulo={<Select
                        value={ plataformaSeleccionada }
                        onChange={(e)=>{
                          setPlataformaSeleccionada(e);                      
                        }}
                        options={ plataformas }
                      />}
                    lista={usuarios}
                    columnas={[
                      { columna: "id", label: "ID" },
                      { columna: "estatus", label: "Activo"},
                      { columna: "username", label: "Usuario" },
                      { columna: "persona.nombre", label: "Nombre" },
                      { columna: "persona.aPaterno", label: "Apellido" },
                      {
                        columna: "isUsingMfa",
                        label: "MFA",
                        //form: (u) => u.isUsingMfa ? "Activado" : "Desactivado",
                      },
                      {
                        columna: "acciones",
                        label: "Acción",
                        form: (u) => (
                          <Button
                            size="sm"
                            color={u.isUsingMfa ? "danger" : "success"}
                            onClick={() => toggleMfa(u)}
                          >
                            {u.isUsingMfa ? "Desactivar" : "Activar"}
                          </Button>
                        ),
                      },
                    ]}
                    id="id"
                    selected={() => {}}
                    csvname={plataformaSeleccionada.label+"-Usuarios"}
                    paginacion={true}
                    elementosPorPagina={30}
                    resaltarFuncion={(e)=>{
                      return !e.estatus ? true: false
                    }}
                    resaltarColor={(e)=>{
                      if( !e.estatus){
                        return "rgba(242, 151, 151, 0.41)";
                      }
                      //return "rgba(58, 223, 149, 0.25)";
                    }}
                  />
                )}
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </div>
    </SiteWrapper>
  );
}

export default UsuariosMfaPage;
